export default __webpack_public_path__ + "static/media/mamy.678bd69e.svg";